import { mapActions } from "vuex";
const FCMixin = {
	data: () => ({
		keyList: [], //必填项列表
		editModal: {}, //弹出框编辑模型
		paramVisible: false, //是否能保存
		addAuth: false, //新增权限
		updateAuth: false, //更新权限
		importAuth: false, //导入权限
		exportAuth: false, //导出权限
		deleteAuth: false, //删除权限
		downloadAuth: false, //下载权限
		cancelAuditAuth: false, //取消审核权限
		auditAuth: false, //审核权限
		mergeAuth: false, //合并权限
		viewAuth: false, //查看权限
	}),
	created() {
		this.getPageUserAction();
	},
	methods: {
		...mapActions("user", ["getUserAction"]),
		log11() {
		},
		getPageUserAction() {
			var _this = this
			let param = {
				account: this.$store.state.user.account,
				code: this.$store.state.user.resourceCode
			}
			console.log(param,"123")
			this.getUserAction(param).then((res) => {
				console.log(res)
				for (let i = 0; i < res.responseData.length; i++) {
					let item = res.responseData[i];
					switch(item.privilegeCode){
						case "add":_this.addAuth = true;break;
						case  "update":_this.updateAuth = true;break;
						case  "export":_this.exportAuth = true;break;
						case  "import":_this.importAuth = true;break;
						case  "del":_this.deleteAuth = true;break;
						case  "audit":_this.auditAuth = true;break;
						case  "merge":_this.mergeAuth = true;break;
						case  "view":_this.viewAuth = true;break;
						case  "cancelAudit":_this.cancelAuditAuth = true;break;
						case  "download":_this.downloadAuth = true;break;
					}
					// if (item.privilegeCode == "add"){
					// 	_this.addAuth = true;
					// }
					// if (item.privilegeCode == "update"){
					// 	_this.updateAuth = true;
					// }
					// if (item.privilegeCode == "export"){
					// 	_this.exportAuth = true;
					// }
					// if (item.privilegeCode == "import"){
					// 	_this.importAuth = true;
					// }
					// if (item.privilegeCode == "del"){
					// 	_this.deleteAuth = true;
					// }
					// if(item.privilegeCode == "download"){
					// 	_this.downloadAuth = true;
					// }
					// if (item.privilegeCode == "download"){
					// 	_this.downloadAuth = true;
					// }
				}
			});
		},
		//校验字段是否为空
		isNull(str) {
			if (!str || str === "" || Object.keys(str).length == 0 || str === null || str === undefined || typeof str === undefined) {
				return true
			}
			return false
		},
		//校验弹出框必填项
		checkParam() {
			for (let i = 0; i < this.keyList.length; i++) {
				const key = this.keyList[i]
				if (this.isNull(this.editModal[key])) {
					this.paramVisible = false
					return
				}
			}
			this.paramVisible = true
		},
		//时间戳转yyyy年mm月dd日
		dateToString(time) {
			let date = new Date(time);
			return date.getFullYear() + "-" +
				 ((date.getMonth() + 1) > 9 ? date.getMonth() + 1 : ("0" + (date.getMonth() + 1))) + "-" +
				 (date.getDate() > 9 ? date.getDate() : ("0" + date.getDate())) + " " +
			     (date.getHours() > 9 ? date.getHours(): ("0" + date.getHours() ) )+ ":" +
			     (date.getMinutes() > 9 ? date.getMinutes() : ("0" + date.getMinutes()))
		}
	}
}
export default FCMixin
